import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";

const App = ({ email }) => (
  <Result
    status="success"
    title="Successfully Registered!"
    subTitle={`Akun Anda (${email}) sekarang sudah Aktif`}
    extra={[
      <Link to="/login" key="login">
        <Button type="primary">Login</Button>
      </Link>,
    ]}
  />
);
export default App;
